export default __webpack_public_path__ + "static/media/bg_timeline.32d2f048.png";